// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__92ymX","svgLogo":"Logo_svgLogo__AXZrx"};